import React, { useEffect } from "react";
import { DataBox } from "./DataBox";
import { PageHeader } from "./PageHeader";
export function InventoryInterval() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}

